/* eslint-disable max-len */

import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

function AttachmentIcon(props: SvgIconProps): React.ReactElement {
  return (
    <SvgIcon width="24" height="25" viewBox="0 0 24 25" fill="none" {...props}>
      <path d="M16.5 6.5V18C16.5 20.21 14.71 22 12.5 22C10.29 22 8.5 20.21 8.5 18V5.5C8.5 4.12 9.62 3 11 3C12.38 3 13.5 4.12 13.5 5.5V16C13.5 16.55 13.05 17 12.5 17C11.95 17 11.5 16.55 11.5 16V6.5H10V16C10 17.38 11.12 18.5 12.5 18.5C13.88 18.5 15 17.38 15 16V5.5C15 3.29 13.21 1.5 11 1.5C8.79 1.5 7 3.29 7 5.5V18C7 21.04 9.46 23.5 12.5 23.5C15.54 23.5 18 21.04 18 18V6.5H16.5Z" />
    </SvgIcon>
  );
}

export default AttachmentIcon;
